@if (sections) {
  <div class="row" #sortableContainer>
    @for (section of sections; track section.id) {

        <div class="sortable-container-item col col-12 col-lg-{{ section.width * 4 }}"
             mwlResizable
             [attr.data-id]="section.id"
             [enableGhostResize]="true"
             (resizeEnd)="onResizeEnd($event, section)">

          <app-cards-basic>
            @if(section.id != editSectionId){
              <h3 style="padding-left: 15px"
                  class="pb-2"
                  matTooltip="Click to edit"
                  matTooltipClass='bp-tooltip'
                  (click)="toggleEditSection(section.id, $event)">
                {{ section.translations[currentLanguage].title || 'Emtpy Title'}}
              </h3>

              <mat-icon class="drag-indicator">
                <span class="material-symbols-outlined">drag_indicator</span>
              </mat-icon>
              <button mat-icon-button aria-label="Delete Button" class="delete-button"
                      (click)="confirmDelete(section.id, $event)">
                <mat-icon><span class="material-symbols-outlined">delete</span></mat-icon>
              </button>
              <mat-icon class="expand-indicator">
                <span class="material-symbols-outlined">expand_content</span>
              </mat-icon>

              <div class="resize-handle-right" mwlResizeHandle [resizeEdges]="{ right: true }"></div>
            } @else {
              <app-content-block-edit
                [contentBlock]="section"
                [fieldToEdit]="'title'"
                [selectedLanguage]="editLanguage"
                (languageChange)="editLanguage = $event"
                (save)="updateSectionTitle(section)"
                (cancel)="toggleEditSection(section.id)"
                (delete)="deleteSection(section.id)">
              </app-content-block-edit>
            }

            <app-section-detail-admin
              [sectionID]="section.id"
              [productID]="productID()"></app-section-detail-admin>
          </app-cards-basic>
        </div>

    }
  </div>
}

@if (isAddingNewSection) {
  <app-cards-basic title="Add new Section">
    <app-content-block-edit
      [contentBlock]="newSection"
      [fieldToEdit]="'title'"
      [selectedLanguage]="editLanguage"
      (languageChange)="editLanguage = $event"
      (save)="addSection()"
      (cancel)="toggleFormVisibility()">
    </app-content-block-edit>
  </app-cards-basic>

} @else {
  <div class="mb-5">
    <button mat-flat-button
            color="primary"
            (click)="toggleFormVisibility()"
            class="mt-3 bp-button">
      Add new Section
    </button>
  </div>
}


<script>
  $(document).ready(function () {
    $("#sortable").sortable();
    $("#sortable").disableSelection();
  });
</script>
